import React from 'react';
import { Layout } from '@eventbrite/eds-layout';
import { connect } from 'react-redux';
import { CollectionCarousel } from '@eventbrite/collection-carousel';
import { gettext } from '@eventbrite/i18n';
import { useHasEnteredViewport, useGetPlacesForCollection } from './hooks';

import './CollectionCarouselContainer.scss';

const CollectionHeader = () => (
    <div className="collection__featured-collections__carousel-header--title">
        <p className="eds-text-hs">{gettext('More hand-picked')}</p>
        <p className="eds-text-hm eds-text-color--primary-brand">
            {gettext('Collections')}
        </p>
    </div>
);

const CollectionSubtitle = () => (
    <div className="collection__featured-collections__carousel-header--subtitle">
        {gettext(
            'Discover more of the best in food, music, wellness, and more with our curated event collections',
        )}
    </div>
);

const FeaturedCollectionCarousel = (props) => {
    const ref = React.useRef(null);
    const [isCollectionCarouselRendering, setIsCollectionCarouselRendering] =
        React.useState(false);
    const isInViewport = useHasEnteredViewport(ref);
    const place = useGetPlacesForCollection(
        props.id,
        props.isOnline,
        isInViewport,
    );

    return (
        <section ref={ref}>
            {isInViewport ? (
                <div
                    className={`collection__featured-collections ${
                        isCollectionCarouselRendering ? '' : 'eds-hide'
                    }`}
                >
                    <Layout maxWidth="large" hasHorizontalGutters={true}>
                        <CollectionCarousel
                            collectionCardContainerClassname="collection__featured-collections--card"
                            tld={props.tld}
                            currentPlace={place}
                            collectionBlockList={[props.id]}
                            lazilyRenderOffScreenElements={true}
                            cardsPerSlide={{ desktop: 2, tablet: 2 }}
                            headerTitle={<CollectionHeader />}
                            headerSubtitle={<CollectionSubtitle />}
                            onMount={(isRendering) =>
                                setIsCollectionCarouselRendering(isRendering)
                            }
                        />
                    </Layout>
                </div>
            ) : null}
        </section>
    );
};

const _mapStateToProps = (state) => ({
    id: state.collection.id,
    isOnline: state.collection.isOnline,
    tld: state.tld,
});

export const CollectionCarouselContainer = connect(_mapStateToProps)(
    FeaturedCollectionCarousel,
);
